import React, { useEffect, useState, useRef } from 'react';
import './EventosHome.css';
import baseURL from '../url';
import SwiperCore, { Navigation, Pagination, Autoplay } from 'swiper/core';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faCalendarAlt,
    faTimes,
    faSearchPlus,
    faChevronLeft,
    faChevronRight
} from '@fortawesome/free-solid-svg-icons';
import whatsappIcon from '../../images/wpp.png';

SwiperCore.use([Navigation, Pagination, Autoplay]);

export default function EventosHome() {
    const [eventos, setEventos] = useState([]);
    const [loading, setLoading] = useState(true);
    const [eventoSeleccionado, setEventoSeleccionado] = useState(null);
    const [modalOpen, setModalOpen] = useState(false);
    const [telefonoContacto, setTelefonoContacto] = useState('');
    const swiperRef = useRef(null);

    useEffect(() => {
        cargarEventos();
        cargarContacto();
    }, []);

    const cargarEventos = () => {
        fetch(`${baseURL}/eventosGet.php`, {
            method: 'GET',
        })
            .then(res => res.json())
            .then(data => {
                setEventos(data.eventos || []);
                setLoading(false);
            })
            .catch(err => {
                console.error('Error al cargar eventos:', err);
                setLoading(false);
            });
    };

    const cargarContacto = () => {
        fetch(`${baseURL}/contactoGet.php`, { method: 'GET' })
            .then(res => res.json())
            .then(data => {
                const contactos = data.contacto || [];
                if (contactos.length > 0 && contactos[0]?.telefono) {
                    setTelefonoContacto(contactos[0].telefono.replace(/\D/g, ''));
                }
            })
            .catch(err => console.error('Error al cargar contacto:', err));
    };

    const abrirDetalle = (evento) => {
        setEventoSeleccionado(evento);
        setModalOpen(true);
    };

    const cerrarDetalle = () => {
        setModalOpen(false);
        setEventoSeleccionado(null);
    };

    const consultarPorWhatsapp = (e, evento) => {
        e.stopPropagation();
        const phone = telefonoContacto || '51999999999';
        const mensaje = `Hola, quisiera más información sobre el evento: "${evento.nombre}" de DXN Tingo María.`;
        const url = `https://api.whatsapp.com/send?phone=${phone}&text=${encodeURIComponent(mensaje)}`;
        window.open(url, '_blank');
    };

    if (loading || eventos.length === 0) {
        return null;
    }

    return (
        <section className="eventosHomeSection" id="eventos-section">
            <div className="eventosHomeHeaderContainer">
                <div className="eventosHomeHeader">
                    <h2 className="eventosHomeTitle">Próximos Eventos y Capacitaciones</h2>
                    <p className="eventosHomeSubtitle">
                        Participa en nuestras actividades oficiales, capacitaciones de liderazgo y encuentros de la familia DXN Tingo María.
                    </p>
                </div>

                {/* Flechas de navegación para el carrusel */}
                {eventos.length > 3 && (
                    <div className="eventosCarouselNav">
                        <button className="swiper-prev-eventos" aria-label="Evento anterior" type="button">
                            <FontAwesomeIcon icon={faChevronLeft} />
                        </button>
                        <button className="swiper-next-eventos" aria-label="Siguiente evento" type="button">
                            <FontAwesomeIcon icon={faChevronRight} />
                        </button>
                    </div>
                )}
            </div>

            {/* Carrusel Swiper: Máximo 3 eventos visibles a la vez en escritorio */}
            <div className="eventosCarouselWrapper">
                <Swiper
                    navigation={{
                        prevEl: '.swiper-prev-eventos',
                        nextEl: '.swiper-next-eventos',
                    }}
                    pagination={{
                        clickable: true,
                        dynamicBullets: true
                    }}
                    slidesPerView={3}
                    spaceBetween={24}
                    breakpoints={{
                        320: {
                            slidesPerView: 1.12,
                            spaceBetween: 14,
                        },
                        640: {
                            slidesPerView: 2,
                            spaceBetween: 18,
                        },
                        1024: {
                            slidesPerView: 3,
                            spaceBetween: 24,
                        }
                    }}
                    className="eventosSwiper"
                >
                    {eventos.map((evento) => (
                        <SwiperSlide key={evento.idEvento} className="eventoSwiperSlide">
                            <article
                                className="eventoCard"
                                onClick={() => abrirDetalle(evento)}
                                title={`Click para ampliar imagen de ${evento.nombre}`}
                            >
                                {evento.imagen ? (
                                    <img
                                        src={evento.imagen}
                                        alt={evento.nombre}
                                        className="eventoCardFullImage"
                                        loading="lazy"
                                    />
                                ) : (
                                    <div className="eventoCardImagePlaceholder">
                                        <FontAwesomeIcon icon={faCalendarAlt} />
                                        <span>{evento.nombre}</span>
                                    </div>
                                )}

                                <div className="eventoCardHoverOverlay">
                                    <span className="eventoCardZoomBadge">
                                        <FontAwesomeIcon icon={faSearchPlus} /> Ampliar
                                    </span>
                                </div>
                            </article>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>

            {/* Modal de Detalle de Evento: Únicamente Imagen Completa sin texto + Botón WhatsApp pequeño encima */}
            {modalOpen && eventoSeleccionado && (
                <div className="eventoModalBackdrop" onClick={cerrarDetalle}>
                    <div
                        className="eventoModalOnlyImageContainer"
                        onClick={(e) => e.stopPropagation()}
                    >
                        {/* Botón cerrar flotante */}
                        <button
                            className="eventoModalCloseBtn"
                            onClick={cerrarDetalle}
                            aria-label="Cerrar imagen"
                            type="button"
                        >
                            <FontAwesomeIcon icon={faTimes} />
                        </button>

                        <div className="eventoModalImageWrapperFull">
                            <img
                                src={eventoSeleccionado.imagen}
                                alt={eventoSeleccionado.nombre}
                                className="eventoModalFullImage"
                            />

                            {/* Botón WhatsApp pequeño flotando encima de la imagen */}
                            <button
                                className="btnWhatsappSmallFloating"
                                onClick={(e) => consultarPorWhatsapp(e, eventoSeleccionado)}
                                title="Consultar por WhatsApp"
                                type="button"
                            >
                                <img src={whatsappIcon} alt="WhatsApp" className="wppIconSmall" />
                                <span>Consultar</span>
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </section>
    );
}
